import MarketPulseSurvey from './MarketPulseSurvey';

export default MarketPulseSurvey;